"use client";
import { motion } from "framer-motion";
import Image from "next/image";

const logos = [
  { src: "/logo/certis.avif", alt: "Certis Cisco", cols: 2, rows: 1 },
  {
    src: "/logo/changiairportgroup.avif",
    alt: "Changi Airport Group",
    cols: 2,
    rows: 1,
  },
  {
    src: "/logo/tcs.avif",
    alt: "TCS TATA Consultancy Services",
    cols: 2,
    rows: 1,
  },
  {
    src: "/logo/lagardere.avif",
    alt: "Lagardere Travel Retail",
    cols: 1,
    rows: 1,
  },
  { src: "/logo/shilla.avif", alt: "The Shilla Duty Free", cols: 1, rows: 1 },
  { src: "/logo/dnata.avif", alt: "DNATA", cols: 2, rows: 1 },
  { src: "/logo/sift.avif", alt: "Sift & Pick", cols: 1, rows: 1 },
  { src: "/logo/sats.avif", alt: "SATS", cols: 1, rows: 1 },
  { src: "/logo/smartecarte.avif", alt: "Smartecarte", cols: 2, rows: 1 },
  { src: "/logo/ica.avif", alt: "ICA", cols: 1, rows: 1 },
  { src: "/logo/pa.avif", alt: "People's Association", cols: 1, rows: 1 },
  {
    src: "/logo/jewelchangi.avif",
    alt: "Jewel Changi Airport",
    cols: 1,
    rows: 1,
  },
  { src: "/logo/starbucks.avif", alt: "Starbucks", cols: 1, rows: 1 },
  { src: "/logo/uniqlo.avif", alt: "Uniqlo", cols: 2, rows: 1 },
  { src: "/logo/julies.avif", alt: "Julie's", cols: 1, rows: 1 },
  {
    src: "/logo/nkf.avif",
    alt: "National Kidney Foundation",
    cols: 1,
    rows: 1,
  },
  {
    src: "/logo/changigeneralhospital.avif",
    alt: "Changi General Hospital",
    cols: 3,
    rows: 1,
  },
  {
    src: "/logo/KOS.svg",
    alt: "King of Strength Boxing Gym",
  },
];

const ClienteleGrid = () => {
  return (
    <div className="relative w-full flex items-center justify-center min-h-screen">
      <section className="py-10 max-w-5xl">
        <motion.h3
          initial={{ y: 48, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ ease: "easeInOut", duration: 0.75 }}
          className="mb-5 text-2xl font-black uppercase text-zinc-50 text-center"
        >
          Clientele
        </motion.h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 auto-rows-[100px] sm:auto-rows-[120px]">
          {logos.map((logo, index) => (
            <div
              key={index}
              className={`relative flex items-center justify-center bg-gray-200 p-2 sm:p-4 rounded-lg col-span-${logo.cols} row-span-${logo.rows}`}
            >
              <Image
                src={logo.src}
                alt={logo.alt}
                width={100}
                height={50}
                className="object-contain w-full h-full"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ClienteleGrid;
